export const sourceMap = {
    whats_app: 'WhatsApp',
    gmail: 'Gmail',
    app: 'Magic Upload',
    ask_aica: 'Ask AICA',
};

export enum HEADER_TITLE {
    ORGANISATION_NAME = 'Organisation Name',
    SOURCE = 'Source',
    UPLOADED_BY = 'Uploaded By',
    DATA_TYPE = 'Data Type',
    REQUESTED_BY = 'Sources',
}

export enum KEY_NAME {
    ASSESSEE_ORGID_LIST = 'assesseeOrgIdList',
    SOURCES = 'sources',
    USER_IDS = 'userIds',
    DATA_TYPES = 'dataTypes',
    REQUESTED_BY = 'requestedBy',
}
export const NEED_INFO = 'needInfo';
export const MAGIC_UPLOAD = 'magicUpload';
export const MAGIC_SIGN = 'magicSign';
// Search-param/config literals the Magic Upload routing/open flow shares with MAGIC_UPLOAD above.
export const IS_COMPANY = 'isCompany';
export const TAB_STATE_ALL = 'all';
export const MAGIC_LINK_CONFIG_NAME = 'MAGIC_LINK';

export const CLARIFICATION_TYPE = {
    SYSTEM_GENERATED: 'SYSTEM_GENERATED',
    USER_GENERATED: 'USER_GENERATED',
};

export const REQ_SOURCE = ['LENDER_BASE_CONFIG', 'PNO_BASE_CONFIG'];
export const SHOW_AI_FOR = ['EMAIL_THREAD', 'MANUAL'];

export const MIME_TYPES = {
    rar: 'application/x-compressed',
    zip: 'application/zip',
    pdf: 'application/pdf',
    oct_stream: 'application/octet-stream',
};

export const WRITE = 'WRITE';

// Mixpanel `entryPoint` values distinguishing where the Magic Upload drawer was opened from.
export const MU_ENTRY_POINT = {
    UPLOAD_JOURNEY: 'uploadJourney',
} as const;

// Fallback categoryId for magic upload when the config-driven categoryId hasn't
// resolved from the Redux slice yet (unhydrated config → '' / null / 0). Sending
// categoryId=null makes mnemosyne throw a generic 500 (RCPI-10599); 2017 is the
// magic-upload staging category, so fall back to it instead of failing the upload.
export const MAGIC_UPLOAD_DEFAULT_CATEGORY_ID = 2017;

export const GLOBAL_SEARCH_GROUPS = {
    ALREADY_ADDED: 'alreadyAdded',
    ADD_NEW: 'addNew',
} as const;

export type GlobalSearchGroupKey = (typeof GLOBAL_SEARCH_GROUPS)[keyof typeof GLOBAL_SEARCH_GROUPS];

// Entity-search card kind, returned by BE on entity-search cards (e.g. two
// same-name results: a sole-proprietor entity vs. a pan-profile individual).
export const ENTITY_TYPE = {
    PERSON: 'PERSON',
    COMPANY: 'COMPANY',
} as const;

export type EntityType = (typeof ENTITY_TYPE)[keyof typeof ENTITY_TYPE];

// Labels for the AddNewPill chip that distinguishes same-name person cards.
export const ENTITY_PILL_LABEL = {
    SOLE_PROPRIETOR: 'Sole Proprietor',
    INDIVIDUAL: 'Individual',
} as const;
